import script from "./fromEmail.vue?vue&type=script&lang=ts&setup=true"
export * from "./fromEmail.vue?vue&type=script&lang=ts&setup=true"

import "./fromEmail.vue?vue&type=style&index=0&id=18d2ec23&lang=scss"

const __exports__ = script;

export default __exports__